import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { WorkerTraining } from '@/features/training/hub'

export const Route = createFileRoute(
  '/_authenticated/_organization/training/'
)({
  beforeLoad: async () => requireRoles(['health_carer', 'supported_employee']),
  component: WorkerTraining,
})
